/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { OrderItemTableRowData } from '@/components/content/OrderItemTable/parts/Table';
import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';

const EMPTY_PRICE = { orderItemPrice: '', currency: '' , freeGift : ''};
export const OrderItemPrice: FC<{isFreeItem?:boolean}> = ({isFreeItem}) => {
	const { price: { orderItemPrice = '', currency = '', freeGift = '' } = EMPTY_PRICE } = useContext(
		ContentContext
	) as OrderItemTableRowData;
	const CartNLS = useLocalization('Cart');
	const price = Number(orderItemPrice);
	return (
		<Stack>
			{isFreeItem ?
				<Typography variant="h6" sx={{ color: '#368632' }}>
					{CartNLS.GRATIS_TEXT.t()}
				</Typography>
			:
				<Typography variant="h6" data-testid="offer-price" id="offer-price">
					<PriceDisplay currency={currency} min={price} />
				</Typography>
			}
		</Stack>
	);
};
